import request from '@/utils/request'

// 通过条件获取红娘信息
export function getMatchmakerInfoByCondition(params) {
    return request({
        url: '/api/MatchmakerInfo/GetMatchmakerInfoByCondition',
        method: 'post',
        data: params
    })
}

// 通过id获取红娘信息
export function getMatchmakerInfo(params) {
    return request({
        url: '/api/MatchmakerInfo/Get',
        method: 'get',
        params: params
    })
}

// 获取所有红娘信息
export function getAllMatchmakerInfo() {
    return request({
        url: '/api/MatchmakerInfo/GetAllMatchmakerInfo',
        method: 'get',
    })
}

// 分页获取红娘信息
export function getMatchmakerInfoPage(params) {
    return request({
        url: '/api/MatchmakerInfo/GetPageList',
        method: 'post',
        data: params
    })
}


export function updateMatchmakerInfo(data) {
    return request({
        url: '/api/MatchmakerInfo/Update',
        method: 'post',
        data: data
    })
}
// 根据会员ID获取跟进记录
export function getFollowUpProgressListByMemberId(data) {
    return request({
        url: '/api/MatchmakerFollowUpMember/GetFollowUpProgressListByMemberId',
        method: 'get',
        params: data
    })
}
// 红娘跟进会员
export function postFollowUpMembers(data) {
    return request({
        url: '/api/MatchmakerFollowUpMember/FollowUpMembers',
        method: 'post',
        data: data
    })
}
// 获取优秀红娘列表
export function getAllExcellentMatchmakerInfo(params) {
    return request({
        url: '/api/MatchmakerInfo/GetExcellentMatchmakerInfoList',
        method: 'get',
        param: params,
    })
}
// 取消跟进会员
export function cancelFollowUpMembers(data) {
    return request({
        url: '/api/MatchmakerFollowUpMember/CancelFollowUpMembers',
        method: 'post',
        data: data
    })
}

// 获取我的积分信息
export function getMyScoreInfo(matchmakerId, page = 1, pageSize = 20) {
    return request({
        url: '/api/MatchmakerInfo/GetMyScoreInfo',
        method: 'get',
        params: { matchmakerInfoId: matchmakerId, page, pageSize }
    })
}

// 根据会员ID获取双向跟进关系
export function getFollowUpRelationshipByMemberId(data) {
    return request({
        url: '/api/MatchmakerFollowUpMember/GetFollowUpRelationshipByMemberId',
        method: 'get',
        params: data
    })
}

// 分页获取跟进关系总览
export function getFollowUpRelationshipOverview(data) {
    return request({
        url: '/api/MatchmakerFollowUpMember/GetFollowUpRelationshipOverview',
        method: 'post',
        data: data
    })
}


// WEBPACK FOOTER //
// ./src/api/matchmakerInfo.js